import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserList } from "hooks";
import { CustomButton } from "core";
import { AddIcon } from "components";
import { BoxHeadlineContainer } from "layout/Container/BoxHeadlineContainer";
import { Routes } from "routes";
import { UserListFilter } from "../UserListFilter";
import { UserListTable } from "../UserListTable";
import useStyles from "./styles";

const UserListPage: React.FC = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { isLoading, userList, cognitoUserList } = useUserList();

  return (
    <BoxHeadlineContainer
      boxTitle="Benutzer"
      boxIcon={Routes.users.icon}
      boxSubTitle={userList.length.toString()}
      paddingHorizontal={0}
      paddingVertical={0}
      className={classes.boxHeadlineContainer}
      boxMenu={
        <CustomButton
          text="Neuer Benutzer"
          size="small"
          iconBefore={<AddIcon />}
          onClick={() => navigate(Routes.users.subNavigations.usercreate.path)}
        />
      }
    >
      <UserListFilter />
      <UserListTable
        isLoading={isLoading}
        userList={userList}
        cognitoUserList={cognitoUserList}
      />
    </BoxHeadlineContainer>
  );
};

export default UserListPage;
